// extracted by mini-css-extract-plugin
export default {"summary":"index_summary_XMyeq","cRed":"index_cRed_Z-ml-"};